export class TenantUrl {

	url: URL;
	tenantId: number;

	constructor(url: string) {
		this.url = new URL(url);

		if (this.url.searchParams.has('tenant_id')) {
			this.tenantId = +this.url.searchParams.get('tenant_id');
			this.url.searchParams.delete('tenant_id');
		}
		const m = this.url.pathname.match(/^\/(\d+)/);
		if (m) {
			this.tenantId = +m[1];
			// eslint-disable-next-line no-useless-escape
			this.url.pathname = this.url.pathname.replace(new RegExp(`^\/${this.tenantId}`), '');
		}
	}

	withPath(path: string) {
		if (path) { this.url.pathname = path; }
		return this;
	}

	withParams(queryParams: Record<string, string | number>) {
		Object.entries(queryParams).forEach(([keyBy, value]) => this.url.searchParams.set(keyBy, value.toString()))
		return this;
	}

	toString() {
		const finalUrl = new URL(this.url.toString());
		if (this.tenantId) {
			finalUrl.pathname = `/${this.tenantId}${finalUrl.pathname}`;
		}
		return finalUrl.toString();
	}
}
